import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        cancel: '&',
        filter: '=',
        defaultFilter: '=',
        selectedColumns: '='
    },
    template: `
<div class="modal-header">
	<button type="button" class="close" ng-click="vm.cancel()"></button>
	<h2>{{ 'report.Export as csv' | translate }}</h2>
</div>
<div class="modal-body">
	<div class="form">
		<label class="label">{{ 'export.Fields to include' | translate }}</label>
		<div class="row">
			<div class="items">
				<ul class="checkboxes">
					<li>
					    <label>
					        <input type="checkbox" ng-model="vm.all" ng-change="vm.handleAllChange()">
					            <strong>{{ 'export.All fields' | translate }}</strong>
                            </input>
                        </label>
                    </li>

                    <!-- User Group -->
                    <li style="margin-top: 15px; padding-left: 20px;">
                        <div style="display: flex; align-items: flex-start;">
                            <strong style="flex: 0 0 120px; max-width: 90px; padding: 5px 8px;">
                                {{ 'export.User' | translate }}
                            </strong>
                            <ul class="checkboxes" style="margin: 0; display: flex; flex-wrap: wrap;">
                                <li ng-repeat="column in vm.userColumns" style="min-width: 300px; margin-right: 12px;">
                                    <label>
                                        <input type="checkbox"
                                         ng-model="vm.selectedColumns[column]"
                                         ng-change="vm.handleColumnChange(column)">
                                            {{ 'export.' + column | translate }}
                                        </input>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <!-- Course Group -->
                    <li style="margin-top: 15px; padding-left: 20px;">
                        <div style="display: flex; align-items: flex-start;">
                            <strong style="flex: 0 0 120px; max-width: 90px; padding: 5px 8px;">
                                {{ 'export.Course' | translate }}
                            </strong>
                            <ul class="checkboxes" style="margin: 0; display: flex; flex-wrap: wrap;">
                                <li ng-repeat="column in vm.courseColumns" style="min-width: 300px; margin-right: 12px;">
                                    <label>
                                        <input type="checkbox"
                                         ng-model="vm.selectedColumns[column]"
                                         ng-change="vm.handleColumnChange(column)">
                                            {{ 'export.' + column | translate }}
                                        </input>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <!-- Activity Group -->
                    <li style="margin-top: 15px; padding-left: 20px;">
                        <div style="display: flex; align-items: flex-start;">
                            <strong style="flex: 0 0 120px; max-width: 90px; padding: 5px 8px;">
                                {{ 'export.Activity' | translate }}
                            </strong>
                            <ul class="checkboxes" style="margin: 0; display: flex; flex-wrap: wrap;">
                                <li ng-repeat="column in vm.activityColumns" style="min-width: 300px; margin-right: 12px;">
                                    <label>
                                        <input type="checkbox"
                                         ng-model="vm.selectedColumns[column]"
                                         ng-change="vm.handleColumnChange(column)">
                                            {{ 'export.' + column | translate }}
                                        </input>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </li>
				</ul>
			</div>
		</div>

		<!-- DRL Row Options -->
		<div class="row" style="margin-top: 20px; padding-top: 20px; border-top: 1px solid #e0e0e0; padding-left: 20px;">
			<div style="display: flex; align-items: flex-start;">
				<strong style="flex: 0 0 120px; max-width: 90px; padding: 5px 8px;">{{ 'export.Row options' | translate }}</strong>
				<div class="items" style="flex: 1;">
					<ul class="checkboxes" style="margin: 0;">
						<li>
							<label>
								<input type="radio" name="drlRowOption" value="separate" ng-model="vm.drlRowOption">
									{{ 'export.Include all Department/Role/Level values on separate rows' | translate }}
								</input>
							</label>
						</li>
						<li>
							<label>
								<input type="radio" name="drlRowOption" value="single" ng-model="vm.drlRowOption">
									{{ 'export.Include all Department/Role/Level values on one row' | translate }}
								</input>
							</label>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<ul class="actions01">
		<li class="primary"><button class="btn main" type="button" ng-click="vm.export()">{{ 'export.Export' | translate }}</button></li>
		<li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
	</ul>
</div>
    `
})
export default class {
    constructor ($window, AuthResource, ReportService, TokenService, lodash) {
        this.$window = $window;
        this.ReportService = ReportService;
        this.AuthResource = AuthResource;
        this.TokenService = TokenService;
        this.lodash = lodash;
        this.all = true;
        this.drlRowOption = 'separate';
    }

    $onInit () {
        // User group columns
        this.userColumns = [
            'employee',
            'userStatus',
            'idCode',
            'email',
            'directManager',
            'sites',
            'department',
            'role',
            'level'
        ];

        // Course group columns
        this.courseColumns = [
            'course',
            'trainingFields',
            'version',
            'occurrenceName',
            'participation',
            'date',
            'expireDate',
            'status',
            'certificateNumber',
            'duration'
        ];

        // Activity group columns
        this.activityColumns = [
            'trainingName',
            'type',
            'associatedForm',
            'trainingDate',
            'trainingDuration',
            'trainingExpectedDuration',
            'result',
            'trainingStatus'
        ];

        // All columns combined
        this.columns = [].concat(this.userColumns, this.courseColumns, this.activityColumns);

        // Initialize selectedColumns as object if not set
        if (!this.selectedColumns || this.selectedColumns.length === 0) {
            this.selectedColumns = {};
            this.columns.forEach((column) => {
                this.selectedColumns[column] = true;
            });
            this.all = true;
        }
        else {
            // Check if all columns are selected
            this.all = this.columns.every(col => this.selectedColumns[col]);
        }
    }

    handleAllChange () {
        if (this.all) {
            // Select all columns
            this.columns.forEach((column) => {
                this.selectedColumns[column] = true;
            });
        }
        else {
            // Unselect all columns
            this.columns.forEach((column) => {
                this.selectedColumns[column] = false;
            });
        }
    }

    handleColumnChange (column) {
        // When a column is deselected, uncheck "All fields"
        if (!this.selectedColumns[column]) {
            this.all = false;
        }
        else {
            // Check if all columns are now selected
            this.all = this.columns.every(col => this.selectedColumns[col]);
        }
    }

    export () {
        // Get selected columns as array
        const selected = this.all === true
            ? this.columns
            : this.columns.filter(col => this.selectedColumns[col]);

        this.filter = this.lodash.assign(this.filter, {
            'selectedColumns[]': selected,
            drlRowOption: this.drlRowOption
        });

        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const qs = this.ReportService.buildQueryString(this.filter);
                const lang = this.TokenService.getActiveLanguage(true);
                const url = `${SEED_CORE.ENV.API_URL}course/course/user-results-report-export?tacToken=${token}&${qs}&_lang=${lang}`;
                this.$window.open(url);
                this.cancel();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/report/employeeresults/export/index.js